export const ActionTypes = {
  FETCH_DOWNTIME_OPERATIONS: 'services/downtimeOperation/fetch_downtime_operations',
  SET_DOWNTIME_OPERATIONS: 'services/downtimeOperation/set_downtime_operations',
  SET_DOWNTIME_OPERATIONS_LOADER_STATUS: 'services/downtimeOperation/set_downtime_operations_loader_status',
  ADD_UPDATE_DOWNTIME_OPERATION: 'services/downtimeOperation/add_update_downtime_operation',
  DELETE_DOWNTIME_OPERATION: 'services/downtimeOperation/delete_downtime_operation',
  CHECK_TIME_RANGE_DOWNTIME_OPERATION: 'services/downtimeOperation/check_time_range_downtime_operation',
  SET_TIME_RANGE_DOWNTIME_OPERATION: 'services/downtimeOperation/set_time_range_downtime_operation',
  SET_DOWNTIME_FILTER: 'services/downtimeOperation/set_downtime_filter',
  ADD_DOWNTIME_FILTER: 'services/downtimeOperation/add_downtime_filter',
  SET_BULK_DOWNTIME_REASON: 'services/downtimeOperation/set_bulk_downtime_reason',
};

const fetchDowntimeOperations = ({ downtimeOperationsParams }) => ({
  downtimeOperationsParams,
  type: ActionTypes.FETCH_DOWNTIME_OPERATIONS,
});

const setDowntimeOperations = ({ downtimeOperationsData }) => ({
  downtimeOperationsData,
  type: ActionTypes.SET_DOWNTIME_OPERATIONS,
});

const setDowntimeOperationsLoaderStatus = ({ downtimeOperationsLoader }) => ({
  downtimeOperationsLoader,
  type: ActionTypes.SET_DOWNTIME_OPERATIONS_LOADER_STATUS,
});

const addUpdateDowntimeOperation = ({ actionName, downtimeOperationObj, downtimeOperationsParams, callback }) => ({
  actionName,
  downtimeOperationObj,
  downtimeOperationsParams,
  type: ActionTypes.ADD_UPDATE_DOWNTIME_OPERATION,
  callback,
});

const setBulkDowntime = ({ bulkDowntimeList, downtimeOperationsParams, callback }) => ({
  bulkDowntimeList,
  downtimeOperationsParams,
  callback,
  type: ActionTypes.SET_BULK_DOWNTIME_REASON,
});

const deleteDowntimeOperation = ({ downtimeId, downtimeOperationsParams }) => ({
  downtimeId,
  downtimeOperationsParams,
  type: ActionTypes.DELETE_DOWNTIME_OPERATION,
});

const checkTimeRangeDowntimeOperation = ({ downtimeRangeParams }) => ({
  downtimeRangeParams,
  type: ActionTypes.CHECK_TIME_RANGE_DOWNTIME_OPERATION,
});

const setTimeRangeDowntimeOperation = ({ downtimeRangeStatus }) => ({
  downtimeRangeStatus,
  type: ActionTypes.SET_TIME_RANGE_DOWNTIME_OPERATION,
});

const setDowntimeFilter = ({ viewDowntime }) => ({
  viewDowntime,
  type: ActionTypes.SET_DOWNTIME_FILTER,
});
const setDowntimeAddFilter = ({ addDowntime }) => ({
  addDowntime,
  type: ActionTypes.ADD_DOWNTIME_FILTER,
});

export default {
  fetchDowntimeOperations,
  setDowntimeOperations,
  setDowntimeOperationsLoaderStatus,
  addUpdateDowntimeOperation,
  deleteDowntimeOperation,
  checkTimeRangeDowntimeOperation,
  setTimeRangeDowntimeOperation,
  setDowntimeFilter,
  setDowntimeAddFilter,
  setBulkDowntime,
};
